import { useCallback } from 'react';
import { useSubmitDialog } from 'server';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { useShowNotification } from 'js/hooks/useShowNotification';

import * as Types from '../types';

export const useHandleSubmitDialog = () => {
    const submitDialog = useSubmitDialog();
    const getErrorMessage = useGetErrorMessage();
    const showNotification = useShowNotification();

    return useCallback(async (
        { submitActionType, actionId, afterSubmitAction }: Types.IHandleSubmitDialogParams
    ): Promise<void> => {
        try {
            await submitDialog({ actionSubmitted: submitActionType, actionId });

            if (afterSubmitAction) {
                await afterSubmitAction();
            }
        } catch (error: any) {
            showNotification(getErrorMessage(error), { variant: 'error' });
        }
    }, [submitDialog, getErrorMessage, showNotification]);
};
